module.exports = __webpack_public_path__ + "img/futb-04.a53be6e0.jpg";